import {
  CardWrapper,
  Wrapper,
  Card,
  CardMedia,
  CardTitle,
  StyledLink,
} from './styles';

const cardData = [
  {
    to: '/companies/list',
    img: 'CompaniesIcon',
    title: 'Companies',
    testId: 'companies-link',
  },
  {
    to: '/companies/tree-list',
    img: 'TreeListIcon',
    title: 'Accounts Tree List',
    testId: 'tree-list-link',
  },
  {
    to: '/companies/user-account-access',
    img: 'TreeListIcon',
    title: 'WD3 Users Access Configuration',
    testId: 'user-account-access-link',
  },
];

export default function AccountManagementHome() {

  return (
    <Wrapper className="account-management-home" data-test="account-management-home">
      {cardData.map((card, index) => (
        <CardWrapper className="card-wrapper" key={index}>
          <Card>
            <StyledLink to={card.to} data-test={card.testId}>
              <CardMedia img={card.img}></CardMedia>
              <CardTitle className="card-title">{card.title}</CardTitle>
            </StyledLink>
          </Card>
        </CardWrapper>
      ))}
    </Wrapper>
  );
}
